import React from 'react';
import '../general/General.css';
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";


const Kanjimanadhi = () => {
    return (
        <>
            <Navbar />
            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <Breadcrumbs /><br />

                        <br />
                        <h2><b>காஞ்சிமாநதி:</b></h2>
                        <br />

                        <p>
                            பெரியபொன்னாச்சியம்மன், சின்னபொன்னாச்சியம்மன் கோயிலின் அருகிலும், பழம்பெரும் வரலாற்றுச் சிறப்புடைய விதரியின் வடக்கு எல்லையாகவும் திகழ்வது நொய்யல் ஆறு.
                            &QUOT;ஆறில்லா ஊருக்கு அழகு பாழ்&QUOT; என்பது பழமொழி. அத்திப்பாளையம் பகுதிக்கு அழகூட்டுவதும், வளம் தருவதும் நொய்யல் ஆறு ஆகும்.
                        </p>

                        <p>
                            கொங்குநாட்டில் தோன்றிக் கொங்குநாட்டில் பாய்ந்து, கொங்குநாட்டு எல்லையிலேயே காவிரியோடு கலக்கும் ஆறு — காஞ்சிமாநதி என்னும் நொய்யல் ஆறு ஆகும்.
                        </p>

                        <h2><b>தோற்றம்:</b></h2>

                        <p>
                            கொங்குநாட்டின் மேற்கு எல்லையாக திகழும் வெள்ளியங்கிரி மலைப்பகுதியில் தோன்றி, பெரும்பாலும் கிழக்கு நோக்கி சுமார் 170 கிலோமீட்டர் பயணம் செய்து காவிரியோடு கலக்கிறது காஞ்சிமாநதி.
                        </p>

                        <p>
                            கிழார் சி.எம். இராமச்சந்திரன் செட்டியார், வெள்ளியங்கிரி மலையிலிருந்து புறப்படும் காஞ்சிமாநதியை, கோவை ஒரு வில்லிலிருந்து புறப்படும் அம்புக்கு ஒப்பிட்டு கூறுவார்.
                        </p>

                        <p>
                            வெள்ளியங்கிரியின் பல்வேறு பகுதிகளில் தோன்றும் பல சிற்றாறுகள் காஞ்சிமாநதியில் சேர்கின்றன. முதலில் 2000 மீட்டர் உயரத்தில் உள்ள &QUOT;ஆண்டிகனை&QUOT; நீர் காஞ்சிமாநதியில் சேர்கிறது.
                        </p>

                        <p>
                            மையமாக வரும் நொய்யலாற்றின் தென்பகுதியில் தர்மலிங்கம் மலை, எட்டிமடை மலை, அய்யாசாமி மலை, ஓரத்திமலை, கூத்தாண்டிமலை, குச்சிமலை ஆகியனவும்;
                            மேற்குப்பகுதியில் அத்திமலை, கரிமலை, குஞ்சரமுடி, பொறத்திமலை, வெள்ளியங்கிரி, முக்கை, தும்பிமுடி, வரடிமலை ஆகியனவும்;
                            வடபகுதியில் இடிஞ்சமலை, பெருமாள் முடி, மருதமலை ஆகியனவும் உள்ளன.
                        </p>

                        <p>
                            தோன்றும் பெரியாறு, கொடுவாய்ப்பள்ளம், நந்தன்கரை பள்ளம், இரண்டும் சேரும் சின்னாறு, கரிமலையில் இருட்டுப்பள்ளம், வெள்ளியங்கிரியில் தோன்றும் சுவாமிமுடியாறு, ஆனையாறு,
                            பூண்டியாறு, நீலிவாய்க்கால், ஓரத்திப்பள்ளம், அய்யாசாமிமலைப் பள்ளம், ஆனைப்பள்ளம், பாம்பாட்டிப்பள்ளம், சங்கனூர்ப் பள்ளம், தடாகப்பள்ளம், திருப்பூராறு,
                            வண்ணாற்றங்கரை, நள்ளாறு முதலிய பல ஆறுகளும், பள்ளங்களும், ஓடைகளும், அருவிகளும் காஞ்சிமாநதியோடு கலக்கின்றன.
                        </p>

                        <p>
                            முட்டம் அருகேயுள்ள ஒரு துணையாற்றுக்கு இன்றும் காஞ்சிமாநதி என்றே பெயரிட்டு அழைக்கின்றனர்.
                        </p>

                        <h2><b>கொங்கு நாட்டு ஆறுகள்:</b></h2>

                        <p>
                            கார்மேகக் கவிஞரின் கொங்குமண்டல சதகமும் வாலசுப்பக் கவிராயரின் கொங்குமண்டல சதகமும் கொங்கு நாட்டு ஆறுகளைக் தொகுத்துக் கூறுகின்றன.
                        </p>

                        <p>
                            திருமணிமுத்தாறு, நள்ளாறு, தொப்பையாறு, காவிரியாறு, செய்யாறு, பாலையாறு, பவானியாறு, காரியாறு, காஞ்சியாறு, ஆனர்பொருதை, சண்பகத்தி சிற்றாறு என்பன அவ்வாறுகளாகும்.
                        </p>

                        <p>
                            இதனை,
                        </p>

                        <blockquote>
                            திருமணி தொப்பைபூங் காவேரி வானியும் செய்யததி<br />
                            தருமணி காஞ்சி பொருதை நள்ளாறொடு சண்முகமும்<br />
                            குருமணி பாலை நதிவாளை காரி குடகனதி<br />
                            வருமணி சணிபகம் சிற்றாறு சூழ்கொங்கு மண்டலமே
                        </blockquote>

                        <p>
                            என்ற சதகப்பாடல் விளக்கும். இங்கு 15 ஆறுகள் தொகுத்துக் கூறப்பட்டுள்ளன.
                        </p>

                        <p>
                            ஆனால் கிராமபத்திரன் பட்டயம், தென்கரை நாட்டுப் பட்டயம் போன்றவை: சிற்றாறு, காவேரியாறு, குடகனாறு, நல்லமங்கையாறு, நல்லாறு, வானியாறு,
                            காஞ்சிமாநதி, ஆண்பொருநையாறு, உப்பாறு, மீன்கொல்லியாறு, நன்காஞ்சியாறு ஆகிய பதினொறு ஆறுகளைத் தொகுத்துக் கூறுகின்றன.
                        </p>

                        <p>
                            மலிபுனல் நிகழ்தரும் நீர் விழாவில்:
                        </p>

                        <blockquote>
                            பொழில்வரி வேனில் பேரெழில் வாழ்க்கை<br />
                            மேவரு சுற்றமொடு கண்டினிது நுகரும்<br />
                            தீம்புனல் ஆயம் ஆடும்<br />
                            காஞ்சியம் பெருந்துறை மணலினும் பலவே
                        </blockquote>

                        <p>
                            என்பது பதிற்றுப் பத்து பாடலாகும்.
                        </p>

                        <p>
                            முற்காலப் பாண்டியன் நெடுஞ்சடையன் பராந்தகனின் சீவரமங்கலச் செப்பேட்டில்:
                        </p>

                        <blockquote>
                            &QUOT;மீகொங்கில் காஞ்சிவாய்ப் பேரூர் புக்குத்<br />
                            திருமாலுக்குக் குன்றமன்னதோர் கோயிலாக்கியும்&QUOT;
                        </blockquote>

                        <p>
                            என்று கூறப்படுகிறது.
                        </p>

                        <p>
                            கொங்கு நாட்டுக்கு மூன்றுமுறை தலயாத்திரை வந்தவரும், கொடுமுடியைப் பாடி மகிழ்ந்தவரும் ஆகிய தேவாரம் பாடிய சுந்தரர்,
                        </p>

                        <blockquote>
                            &QUOT;மீகொங்கில் அணி காஞ்சிவாய்ப் பேரூர்ப் பெருமானைப்<br />
                            புலியூர்ச் சிற்றம்பலத்தே பெற்றாய் அன்றே&QUOT;
                        </blockquote>

                        <p>
                            என்று பாடியுள்ளார்.
                        </p>

                        <blockquote>
                            &QUOT;கொந்துலவு காஞ்சிநதி சவுந்தரமா நதிவானி குலாவி விளங்குநாடு<br />
                            கூர்த்த சங்கத்தையும் தாதியால் வெற்றிசெயும் குறுப்புநன் நாடுதானே&QUOT;
                        </blockquote>

                        <blockquote>
                            &QUOT;கனசென்னிமலை காஞ்சியான் பொருநை சூழ்கின்ற காங்கய நாடுதானே&QUOT;
                        </blockquote>
                        <p>கல்வெட்டில் <strong>எழுகரைநாடு</strong> என்ற தொடர் பயின்று வருகிறது. அருணகிரியாரும் &QUOT;எழுகரைநாட்டள் தம்பிரானே&QUOT; என்று பாடுகிறார்.</p>

                        <p><em>கொங்கு மண்டலத்திலே தெட்சண கைலாசமாகிய<br />
                            அரவகிரியைச் சூழ்ந்த காவேரி பவானி திருமணிமுத்தாறு<br />
                            அலகுமுரிச்சான் தொப்பை ஆப்பிராவதி நொய்யல் ஆக<br />
                            சத்தநதியாகிய எழுகரை நாடு&QUOT;</em>
                        </p>

                        <p>என்று கூறுகிறது. மக்கென்சியின் ஆவணம் ஒன்று எழு ஆறுகளுடன் எழு பாடல் பெற்ற சிவாலயங்கள் உள்ள காரணத்தால் <strong>எழுகரைநாடு</strong> என்று பெயர் பெற்றதாக கூறப்படுகிறது.</p>

                        <p><em>&QUOT;வாணி நொய்யல் காவேரி ஆண்பொருந்தம் ஆனியாறு<br />
                            திருமணிமுத்தாறு தொப்பையாறு ஆக நதி<br />
                            ஏழு சிவாலயத்துக்கு வரலாறு<br />
                            கரூர், வெஞ்சமாங்கூடல், கொடுமுடி, திருநண்ணா, திருமுருகன்பூண்டி, பேரூர்<br />
                            ஆக திருப்பாடல் பெற்ற திருப்பதி<br />
                            ஏழு நதியும் - ஏழு படைவீடும் ஏழு உண்டானபடியாலே<br />
                            கொங்கு மண்டலம் எழுகரைநாடாக சொல்லப்படுகிறது&QUOT;</em> என்பது மக்கென்சியின் ஆவணப்பகுதியாகும்.</p>

                        <p>எல்லாத் தொகுப்புகளிலும் <strong>காஞ்சிமா நதியாகிய நொய்யல்</strong> தவறாமல் இடம்பெற்றிருப்பது சிறப்புக்குரியது ஆகும்.</p>

                        <h3>காஞ்சி:</h3>

                        <p><strong>நொய்யலாற்றுக்கு காஞ்சி</strong> என்பதே பழம்பெயர். பரணர் என்னும் சங்ககாலப் புலவர், கடல்பிறகோட்டிய செங்குட்டுவனைப் பாடிய <em>பதிற்றுப்பத்து</em> என்னும் சங்ககால இலக்கியத்தின் ஐந்தாம்பத்தில் <strong>காஞ்சியாறு</strong> பற்றிப் பாடுகிறார்.</p>

                        <p>வேனில் காலத்தில் கொண்டாடப்படும் நல்ல நிர்விழாவின்போது, கொங்குநாட்டுமக்கள் தங்கள் வீடுகளில் சுற்றத்தார்களுடன் அழகிய சோலையில் தங்கி, இன்பமாக பொழுதை போக்கி, நீராடி, தங்காமல் உண்டுமகிழும் படியான <strong>காஞ்சியாற்று மணலினும்</strong> கடல்பிறகோட்டிய செங்குட்டுவன் வாழ்நாட்கள் மிகுவதாகும் என்கிறார் பரணர்.</p>

                        <p>கொடுமணல் இலக்கியத்தில்:</p>
                        <p><em>&QUOT;சோலை சூழ்ந்திடும் காஞ்சிமாநதி துலங்க வந்தருள் தேவனே&QUOT;</em></p>
                        <p><em>&QUOT;காஞ்சிமாநதி தன்னிலே வளர கன்னி மாமயில் அன்னமே&QUOT;</em></p>
                        <p><em>&QUOT;சிறந்த தாம் திருக்காஞ்சி நதியில் வளரும் செல்வத் துரைமகள்&QUOT;</em></p>

                        <p>என்று <strong>காஞ்சிமாநதி</strong> குறிக்கப்படுகிறது.</p>

                        <p><em>&QUOT;மண்பரவும் காஞ்சிநதி<br />
                            ஆலிக்கும் திருக்காஞ்சிநதி<br />
                            மணக்கும் திருக்காஞ்சி<br />
                            செய்யபுகழ்க் காஞ்சி<br />
                            அருள்பரவும் காஞ்சி&QUOT;</em></p>

                        <p>என்று பல்வேறு இலக்கியத் தொடர்கள் <strong>காஞ்சிமாநதியை</strong>ப் புகழுகிறது.</p>

                        <p>பூந்துறை நாட்டின் எல்லை கூறும் புராணப் பாடலில் தெற்கு எல்லையாக:</p>
                        <p><em>&QUOT;உன்னிய தெற்கில் காஞ்சி&QUOT;</em></p>

                        <p>என்ற தொடர் காணப்படுகிறது.</p>

                        <p><strong>பேரூர் படத்துச் செப்பேடு, பேரூர் செப்பேடு, தென்கரை நாட்டுப்பட்டயம், கொங்கு காணியான 2 நாட்டுப்பட்டயம்</strong> ஆகியவற்றில் <strong>காஞ்சியாறு</strong> என்ற தொடரே பயின்று வருகிறது.</p>

                        <p><strong>விசயநகர மன்னன் இராமதேவ மகாராயர்</strong> பிரதிநிதியாக மதுரையில் <strong>முத்துவீரப்ப நாயக்கம்</strong> ஆட்சி புரியும்போது (கி.பி. 1621), பழையகோட்டைப் பட்டக்காரர் <strong>விசுவநாதச் சர்க்கரை உத்தமக்காமிண்ட மன்றாடியார்</strong> &QUOT;<strong>காஞ்சிறதி திர்த்தத்தில் நவபிரதிட்டையாக அணையும் வாய்க்காலும்</strong>&QUOT; கண்டு பணி செய்ததாக <strong>நத்தக் காரையூர்க் கல்வெட்டு</strong>க் கூறுகிறது.</p>

                        <p><strong>காஞ்சிமாநதி</strong> என்ற பெயர் <strong>முட்டம்</strong> அருகே ஒரு சிற்றாறுக்கு பெயராக வருகிறது. <strong>நன்காஞ்சி (நங்காஞ்சி)</strong> என்ற ஆறு, கொங்கு நாட்டின் தென்பகுதியில் ஓடுகிறது.</p>

                        <p>கொங்கு 24 நாடுகளில் ஒரு நாடு <strong>காஞ்சிகோயில் நாடு</strong> (இது <strong>காஞ்சிக்குறி, காஞ்சிக் கூவல்</strong>) என்று பெயர் பெற்றுள்ளது. அந்நாட்டின் <strong>பூந்துறை நாட்டை</strong> ஒட்டிய பகுதி <strong>காஞ்சித் துண்டம், காஞ்சி கூவத்தூண்டம்</strong> எனப்படுகிறது.</p>
                        <h3>நொய்யல்:</h3>

                        <p>சுந்தரபாண்டியன் ஆகியோரின் சர்க்கார் பெரியபாளையம் சுக்சவேசுரன் கோயில் கல்வெட்டில் &QUOT;நள்ளாறும் நொயிலாறும் கூடும் மூலை&QUOT; என்றும் குறிப்பிடப்பட்டுள்ளது.</p>

                        <p><strong>காஞ்சிமாநதி</strong> என்ற பெயர் மறைந்து, இன்று <strong>நொய்யலாறு</strong> என்ற பெயரே வழங்கி வருகிறது. கி.பி. 13-ஆம் நூற்றாண்டைச் சேர்ந்த கொங்கு சோழன் விக்கிரம சோழன் மற்றும் கொங்கு பாண்டியன் ஆட்சியில்,</p>

                        <p>“நொய்யலாற்றில் இந்தவரி அணையும் அடைத்துக் காலும் வெட்டிக்குளமும் அடைத்து பயிர் செய்து” என்றும் குறிப்பிடப்பட்டுள்ளது.</p>

                        <p><strong>வள்ளிஎறிச்சல் தொண்டைமாக்கவுண்டர்</strong> வரலாற்றுக் குறிப்பிலும் &QUOT;நொய்யல் ஆறு&QUOT; என்றே குறிப்பிடப்பட்டுள்ளது.</p>

                        <p>கொங்கு காணியான பட்டயம், குறுப்புநாட்டு பட்டயம், தென்கரைநாட்டு பட்டயம், முத்தூர் பட்டயம், மோரூர், காங்கேயம் ஏடு போன்றவற்றிலும் &QUOT;நொய்யல்&QUOT; என்ற பெயர் பயன்படுத்தப்பட்டுள்ளது.</p>

                        <p><strong>காஞ்சி</strong> என்ற பெயர், 13-ஆம் நூற்றாண்டில் <strong>நொயில், நொய்யல்</strong> என்று மாறியுள்ளது. இம்மாற்றம் எப்படி ஏற்பட்டது என்பது ஆய்வுக்குரியது.</p>

                        <p>“நொய்” என்பது நுண்மை, சிறுமை, மென்மை, மிருது எனும் பொருளைக் கொண்டது. உடைந்த அரிசி குறுணைக்கு “நொய்க்குறுணை” என்று பெயர். கோதுமை ரவையை “கோதுமை நொய்” என்பர்.</p>

                        <p>தொல்காப்பியத்திற்கு உரை எழுதிய <strong>சேனாவரையர்</strong>, “நொய்யும் நுணுங்கும் நீக்கிச்சோறு சமைத்தல்” என்று குறிப்பிட்டுள்ளார்.</p>

                        <p>கற்களே இல்லாத மென்மையான மணலுக்கு “நொய்மணல்” என்று பெயர். &QUOT;நொய்&QUOT; என்பதற்குச் <strong>சூடாமணி நிகண்டு</strong> “இலேசு” என்ற பொருளைக் கூறுகிறது. &QUOT;குறுநொய்&QUOT; என்ற தொடரை <strong>திவாகர நிகண்டு</strong> எடுத்துக்காட்டுகிறது. அது இன்று “குறுணை” என்று மாறிவிட்டது.</p>

                        <p>“நொய்யரிசி கொதி தாங்காது” என்ற பழமொழியும் உண்டு. நொறுங்கிய அரிசித் துணுக்கை “நொய்” என்று <strong>அபிதான சிந்தாமணி</strong> கூறுகிறது.</p>

                        <p>நுண்மையான, சிறிய, மென்மையான, கல்கலக்காத மணல் <strong>காஞ்சியாற்றில்</strong> கிடைப்பதால், “காஞ்சி நொய்யல்” என்று பெயர் பெற்றிருக்க வேண்டும்.</p>

                        <p>கொங்கு நாட்டின் நொய்யல் கரைப்பகுதியில் கட்டிடம் கட்டுவோர், நொய்யலாற்று மணலை சல்லடையில் சலிக்காமல் அப்படியே காரைக்குப் பயன்படுத்துவதைப் பார்க்கலாம்.</p>

                        <p><strong>கோவைக்கிழார் சி.எம். இராமச்சந்திரஞ் செட்டியார்</strong> தம் “காஞ்சிமாநதி” என்னும் நூலில் நொய்யலாறு பேசுவதாக எழுதியுள்ளார்:</p>

                        <blockquote>
                            <p>&QUOT;நொய் போலச் சிறியவள் நான். கங்கை, யமுனை,<br />
                                சிந்து, கோதாவரி, கிருஷ்ணா, காவிரி, நர்மதை,<br />
                                போன்ற பெரிய நானோ மிகச் சிறியவள். நொய் போன்றவர்<br />
                                ஆறுகளுடன் ஒப்பிட்டுப் பார்த்தால்<br />
                                தானியத்தில் நொய்யிற்குச் சத்து மிகுதி. அதுபோல்<br />
                                அருள்மிகு பொன்னாச்சியம்மன் திருக்கோயில் குடமுழக்கு விழா மலர்<br />
                                அந்தப் பேராறுகளில் ஆயிரத்தில் ஒரு பங்கும்<br />
                                மக்களுக்குப் பயன்படுவதில்லை. நானோ நூற்றுக்கு நூறு பயன் தருவேன்.<br />
                                அதில்தான் சிறப்பு இருக்கிறது.<br />
                                ஆகவே <strong>நொய்யல்</strong> என்ற பெயரே எனக்கு விருப்பம்.&QUOT;</p>
                        </blockquote>

                        <p>இவ்வாறு நொய்யலாறே பேசுவதாகவும் எழுதியுள்ளார்.</p>

                        <p><strong>நொய்யல்</strong> காவிரியோடு கலக்கும் இடத்தில் உள்ள ஊர்ப்பகுதிக்கும், அருகிலுள்ள இரயில் நிலையத்திற்கும் “நொய்யல்” என்றே பெயர். <strong>நொய்யல்</strong> காவிரியோடு கலக்கும் இடத்தில், <strong>கூடுதுறை செல்லாண்டியம்மன் கோயில்</strong> சிறப்புடன் விளங்குகிறது.</p>


                    </div>
                </div>
            </div >
            <Footer /></>
    );
}
export default Kanjimanadhi;